import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import TextFieldReusable from "../textfields/TextFieldReusable";
import { Grid } from "@mui/material";
import ButtonReusable from "../buttons/ButtonReusable";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogReusable = ({
  isDialogOpen,
  onClose,
  onChangeText,
  reducer_data,
  handleSubmit,
}) => {
  if (!isDialogOpen) {
    return null; // Don't render anything if the dialog is not open
  }

  const dialogTitleStyle = {
    background: "",
    backgroundSize: "cover",
    color: "white",
    backgroundColor: "red",
    height: "20px",
  };
  return (
    <form onSubmit={handleSubmit}>
      <React.Fragment>
        <Dialog
          open={isDialogOpen}
          TransitionComponent={Transition}
          keepMounted
          // onClose={onClose}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 900, dialogTitleStyle }}>
            {"Request Quotation"}
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 4, md: 4 }}
              columnSpacing={{ xs: 1, sm: 3, md: 2 }}
            >
              <Grid item xs={4} md={2}>
                <TextFieldReusable
                  title="Name"
                  fullWidth
                  size="small"
                  name="inquirer_name"
                  value={reducer_data.inquiry.inquirer_name}
                  onChange={(e) => onChangeText(e, "inquiry")}
                  required
                />
              </Grid>
              <Grid item xs={4} md={2}>
                <TextFieldReusable
                  title="Email"
                  fullWidth
                  size="small"
                  type="email"
                  name="inquirer_email"
                  value={reducer_data.inquiry.inquirer_email}
                  onChange={(e) => onChangeText(e, "inquiry")}
                  required
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <TextFieldReusable
                  title="Message"
                  fullWidth
                  size="small"
                  multiline={true}
                  rows={5}
                  name="inquirer_message"
                  value={reducer_data.inquiry.inquirer_message}
                  onChange={(e) => onChangeText(e, "inquiry")}
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ paddingRight: "24px", paddingBottom: "16px" }}>
            <ButtonReusable
              buttonName="Cancel"
              onClick={onClose}
              backgroundColor="#cb6262"
              color="white"
              padding="3px 16px"
              fontWeight={200}
              fontSize="12px"
            />
            <ButtonReusable
              buttonName="Submit"
              backgroundColor="#999925"
              color="white"
              padding="3px 16px"
              fontWeight={200}
              fontSize="12px"
              type="submit"
              onClick={handleSubmit}
            />
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </form>
  );
};

export default DialogReusable;
